import React from "react";
import { RouterProvider } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "./shared/context";
import { QueryProvider } from "./shared/providers/QueryProvider";
import { router } from "./app/router";

const App: React.FC = () => (
  <QueryProvider>
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  </QueryProvider>
);

export default App;
